/**
 * Сборка тела initial_geometry для POST /objects/with-card из состояния рисования (режим «сначала карта»).
 */

import { convertCircleToPolygon } from "@/lib/utils";
import { alignGeoJsonToPrimitiveCode } from "@/lib/geojson-primitive-align";
import type { ObjectCreateInitialGeometryPayload } from "@/types/card-template";

export function buildInitialGeometryPayloadForWithCard(
  drawing: Record<string, unknown> | null | undefined,
  activeTool: string | null,
  snap: { name: string; description: string; color: string; opacity: number },
): ObjectCreateInitialGeometryPayload | null {
  if (!drawing) return null;
  const sem = drawing.geometry_kls_id;
  if (sem == null || Number.isNaN(Number(sem))) return null;

  let geoJSONData: unknown =
    typeof drawing.geoJSON === "string"
      ? JSON.parse(String(drawing.geoJSON))
      : (drawing.geoJSON || drawing);

  if (drawing.type === "circle" || activeTool === "draw-circle") {
    geoJSONData = convertCircleToPolygon(geoJSONData as GeoJSON.Feature);
  }

  const primCode =
    typeof drawing.geometry_primitive_code === "string"
      ? drawing.geometry_primitive_code
      : undefined;
  const aligned = alignGeoJsonToPrimitiveCode(geoJSONData as GeoJSON.Feature, primCode);
  geoJSONData = aligned.geojson;

  const gj = geoJSONData as GeoJSON.Feature | GeoJSON.Geometry;
  const g =
    gj && typeof gj === "object" && "type" in gj && gj.type === "Feature"
      ? (gj as GeoJSON.Feature).geometry
      : (gj as GeoJSON.Geometry);
  const geometryType = String(g?.type || aligned.geometryTypeLower || "polygon").toLowerCase();

  const gName = (snap.name || "").trim() || "Геометрия с карты";

  return {
    name: gName,
    description: snap.description || undefined,
    geojson: geoJSONData as GeoJSON.Feature | GeoJSON.Geometry,
    type: geometryType,
    style: {
      color: snap.color,
      fillColor: snap.color,
      weight: 2,
      opacity: snap.opacity / 100,
      fillOpacity: snap.opacity / 200,
    },
    geometry_kls_id: Number(sem),
    geometry_primitive_kls_id:
      drawing.geometry_primitive_kls_id != null
        ? Number(drawing.geometry_primitive_kls_id)
        : undefined,
  };
}
